import { SearchParams, SearchRouteParams } from '@lessonup/typescript-core/domain';
import { searchPlanRoute } from '@lessonup/typescript-core/services';
import React, { useCallback } from 'react';
import { RouteComponentProps } from 'react-router';
import { showTabsForLanguage } from '../../../utils/tabs';
import PlanSearch from './PlanSearch';

type Props = {} & RouteComponentProps<SearchRouteParams>;

const PlanSearchPage: React.FunctionComponent<Props> = (props) => {
  const { history, match } = props;
  const searchParams = SearchParams.fromUrlComponents({
    urlParams: match.params,
    queryString: history.location.search,
    indexType: 'plans',
  });

  const urlCreator = useCallback((params: SearchParams) => {
    const { queryString, urlDict } = SearchParams.searchParamsToUrlComponents(params);
    return searchPlanRoute({
      ...urlDict,
      qs: queryString,
    });
  }, []);

  return <PlanSearch showTabs={showTabsForLanguage()} searchParams={searchParams} urlCreator={urlCreator} />;
};

export default PlanSearchPage;
